export default __webpack_public_path__ + "img/12.asset.1215e36c.jpeg";